import { Box, Chip, MenuItem, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));
const MultipleCountry = ({ countries, allCountry, setCountries, clearCountry }) => {
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [selectedId, setSelectedId] = useState([]);

  const handleChange = e => {
    let exist = selected.some(u => u.id === e.id);
    if (!exist) {
      let old = [...selected, e];
      setSelected(old);
      let ids = [];
      old.map(item => {
        ids.push(item.id);
      });
      setCountries(ids);
    }
  };
  const deleteOne = e => {
    let items = selected.filter(item => item.id != e.id);
    setSelected(items);
    let ids = [];
    items.map(item => {
      ids.push(item.id);
    });
    setCountries(ids);
  };

  useEffect(() => {
    setSelected([]);
  }, [clearCountry]);

  return (
    <Box>
      <TextField
        variant="outlined"
        select
        label="Country"
        size="small"
        fullWidth
        required
        value={countries}
        onChange={e => handleChange(e.target.value)}
        className={classes.inputStyle}>
        {allCountry.map((e, index) => (
          <MenuItem value={{ id: e.code, name: e.name }} key={index}>
            <Box className={classes.inner}>
              <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.name}
            </Box>
          </MenuItem>
        ))}
      </TextField>
      <Box sx={{ py: 5, display: 'flex', gap: '15px' }}>
        {selected.map(e => (
          <Chip color="info" icon={<CloseIcon />} label={e.name} onClick={i => deleteOne(e)} className={classes.chip} />
        ))}
      </Box>
    </Box>
  );
};

export default MultipleCountry;
